var map = {
	"./subnav.de-CH.json": 1377,
	"./subnav.de-DE.json": 1378,
	"./subnav.en-CA.json": 1379,
	"./subnav.en-GB.json": 1380,
	"./subnav.en-IN.json": 1381,
	"./subnav.en-ME.json": 1382,
	"./subnav.en-US.json": 1383,
	"./subnav.es-EM.json": 1384,
	"./subnav.es-ES.json": 1385,
	"./subnav.fr-BE.json": 1386,
	"./subnav.fr-CA.json": 1387,
	"./subnav.fr-CH.json": 1388,
	"./subnav.nl-BE.json": 1389,
	"./subnav.nl-NL.json": 1390,
	"./subnav.pl-PL.json": 1391,
	"./subnav.pt-BR.json": 1392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1376;